module.exports = __webpack_public_path__ + "img/11.c4a291f9.png";